function EventsData() {
    "use strict";

    this.CurrentId = -1;
    this.TargetId = -1;
    this.CurrentTrackpoints = null;
    this.CurrentTrackpointsPaginated = null;

    this.Clean = null;
    this.Sort = null;
    this.Dirty = null;
    this.Paginated = null;
    this.HistoryClean = null;
    this.PaginationData = null;
    this.HistorySort = null;
    this.HistoryDirty = null;
    this.HistoryPaginated = null;

    this.DistancePoints = [];
    this.DistanceToolActive = false;
    this.MapRequestCount = 0;

    this.PlaybackStatus = 'Stopped';
    this.PlaybackDirection = 1;
    this.PlaybackDivider = 1;
    this.MapRenderState = new MapSettingState();
    this.RequestId = null;
    this.IsSort = false;
    this.ReturnEnrolleeId = -1;
}
if (typeof exports !== 'undefined') {
    module.exports = EventsData;
}